<template>
  <div>
   
    <ul>
        <li v-for="membre in MembresDuMenage" :key="membre.id" >{{membre.nom}}</li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    menage: {
      required: true,
    },
  },
  computed: {
    ...mapState({
      MembresDuMenage(state) {
        const filtered = _.filter(state.Membres.MembresDuGroupe, {
          code_menage: this.menage,
        });
        return filtered;
      },
    }),
  },
};
</script>

<style scoped></style>
